import * as React from 'react';
import styled from 'styled-components';
import { getFullIconsName } from '../../constants/iconsName';
// ############################ Styles ###########################
// tslint:disable:variable-name

const icon = (iconName: string, selected: boolean) => {
  if (iconName) {
    const name: string = `${iconName}${selected ? 'Blue' : ''}`;
    const url = getFullIconsName[name];

    return `content: url(${url})`;
  }

  return '';
};

const STab = styled.div<{ selected: boolean; iconName: string }>(({ theme, selected, iconName }) => {
  return `
  font-size: ${theme.font.size.smallMedium3};
  font-weight: ${theme.font.weight.light};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.18;
  letter-spacing: normal;
  max-width: 100%;
  max-height: 75px;
  display: flex;
  align-items: center;
  border-left: ${selected ? 'solid 6px ' + theme.colors.light5 : 'none'};
  padding: ${theme.spacing.mediumLarger}px;
  padding-left: ${theme.spacing.large}px;
  background: ${selected ? theme.colors.tabsBackGround : 'transparent'};
  color:  ${selected ? theme.colors.light5 : theme.colors.headlineGrey4};
  cursor: pointer;

  &:before {
    ${icon(iconName, selected)};
    margin-right: ${theme.spacing.large}px;
  }
  `;
});

// tslint:enable:variable-name
// ############################ End Styles ###########################

// tslint:disable-next-line:no-empty-interface
export interface IITabProps {
  children?: React.ReactNode;
  onClick: () => void;
  iconName?: string;
  selected?: boolean;
  dataAt: string;
}

// tslint:disable-next-line:variable-name
const Tab: React.FC<IITabProps> = ({ iconName = '', onClick, children, selected = false, dataAt }) => {
  return (
    <STab selected={selected} data-at={dataAt} iconName={iconName} onClick={onClick}>
      {children}
    </STab>
  );
};

export default Tab;
